import {apiRoot} from "./apiRoot.ts";


export type Driver = {
    adnDocNumber: string,
    firstName: string,
    lastName: string,
    rioId: string,
    holidayGroup: string
}


export const driverSlice = apiRoot.injectEndpoints({
    endpoints: build => ({
        findAllDrivers: build.query<Driver[], void>({
            query: () => ({
                url: "/api/worktimeexpense/driver",
                method: "GET"
            }),
        }),
    })
})

export const {useFindAllDriversQuery} = driverSlice

function findDriver(drivers: Array<any> | null | undefined, lookupPropertyName: string, lookupPropertyValue: string) {
    return drivers?.find(driver => (driver as any)[lookupPropertyName]?.includes(lookupPropertyValue))
}

export const useDriver = (lookupPropertyName: string, lookupPropertyValue: string) => {

    const {data} = useFindAllDriversQuery()

    return findDriver(data, lookupPropertyName, lookupPropertyValue)
}